import useNavigation from './useNavigation';

interface IParams {
  equipment_id?: string;
}

export default function useBudgetReportNavigation() {
  return useNavigation<IParams>('/budgets');
}
